import React, { useState, useEffect, useContext } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { Switch, Spin, Button, Card } from 'antd';
import { link } from '../../dynamic/api';


import Select from 'react-select';

import { DataContext } from '../../init/getData';

function DevGeneral() {

  const { api, userData, refData, devData, companyId } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;

  const [isLoading, setIsLoading] = useState(true);
  const [devSettingData, setDevSettingData] = useState(null);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['devData']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setDevSettingData(devData);
  }, [devData]);




  const handleSubmit = async (e) => {
    e.preventDefault();


    const settings = devSettingData;


    const res = await api.post(`/dev/edit`, JSON.stringify({ settings }))
    if (res.data.status) {
      toast.success(res.data.message);
    }
    else {
      toast.error(res.data.message);
    }

  }



  const handleChange = (name, value) => {

    setDevSettingData((prev) => ({
      ...prev,
      [name]: value,
    }));


  }

  const handleChangeMode = (name, value) => {
    setDevSettingData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Card >


      <Spin size="large" spinning={isLoading} style={{ margin: 'auto' }} />


      {!isLoading && devSettingData &&

        <Form onSubmit={handleSubmit} style={{ width: '45%', margin: '0', marginTop: '30px' }} id='settingForm'>




          <Form.Group as={Row} className="mb-3">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button style={{ backgroundColor: '#23576a', color: 'white' }} onClick={handleSubmit}>Save</Button>
            </Col>
          </Form.Group>


        </Form>

      }

    </Card >
  );
}

export default DevGeneral;
